// extracted by mini-css-extract-plugin
export default {"section":"style_section__ulclY","signup-form-wrapper":"style_signup-form-wrapper__xV4Vf","register-success-container":"style_register-success-container__YdgEt"};